module.exports = __webpack_public_path__ + "static/media/globeIcon.d26b4d2a.svg";